'use client';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select } from '@/components/ui/select';
import { EmailService } from '@/services/email.service';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { contactUsSchema, ContactUsSchema } from './contactUsSchema';

export function ContactUsForm() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ContactUsSchema>({
    resolver: zodResolver(contactUsSchema),
    mode: 'onChange',
  });

  const onSubmit = async (data: ContactUsSchema) => {
    try {
      await EmailService.sendContactEmail(data);
      toast.success('Mensaje enviado correctamente');
    } catch (error) {
      toast.error((error as Error).message);
    }
  };

  const businessRoles = [
    { label: 'CEO / Director General', value: 'CEO' },
    { label: 'CTO / Director de Tecnología', value: 'CTO' },
    { label: 'CMO / Director de Marketing', value: 'CMO' },
    { label: 'CFO / Director Financiero', value: 'CFO' },
    { label: 'Director de Operaciones', value: 'Director de Operaciones' },
    { label: 'Director de Recursos Humanos', value: 'Director de Recursos Humanos' },
    { label: 'Director de Ventas', value: 'Director de Ventas' },
    { label: 'Director de Producto', value: 'Director de Producto' },
    { label: 'Gerente de Proyectos', value: 'Gerente de Proyectos' },
    { label: 'Gerente de Marketing', value: 'Gerente de Marketing' },
    { label: 'Gerente de Ventas', value: 'Gerente de Ventas' },
    { label: 'Desarrollador / Programador', value: 'Desarrollador / Programador' },
    { label: 'Diseñador UX/UI', value: 'Diseñador UX/UI' },
    { label: 'Analista de Datos', value: 'Analista de Datos' },
    { label: 'Especialista en Marketing Digital', value: 'Especialista en Marketing Digital' },
    { label: 'Consultor', value: 'Consultor' },
    { label: 'Emprendedor / Fundador', value: 'Emprendedor / Fundador' },
    { label: 'Otro', value: 'Otro' },
  ];

  return (
    <div className="flex justify-start items-start gap-6 h-full w-full xl:w-1/3 lg:w-2/3 sm:w-full">
      <div className="p-8 bg-blue-50 rounded-2xl outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-5 h-full w-full overflow-y-auto">
        <Input
          label="¿Cómo te llamas?*"
          placeholder="Tu nombre"
          type="text"
          error={errors.name?.message}
          {...register('name')}
        />
        <Input
          label="Email corporativo*"
          placeholder="tu@empresa.com"
          type="email"
          error={errors.email?.message}
          {...register('email')}
        />
        <Input
          label="¿En qué empresa trabajas?*"
          placeholder="Nombre de tu empresa"
          type="text"
          error={errors.company?.message}
          {...register('company')}
        />
        <Select
          label="¿Cuál es tu rol?"
          placeholder="Seleccionar miembro del equipo"
          error={errors.role?.message}
          {...register('role')}
          options={businessRoles}
        />
        <Input
          label="Cuéntanos brevemente qué necesitas"
          placeholder="Ejemplo: Necesito generar 100 imágenes mensuales para un e-commerce...."
          type="textArea"
          error={errors.message?.message}
          {...register('message')}
        />
        <Button
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          loading={isSubmitting}
          loadingText="Enviando..."
        >
          Agendar mi demo gratuita
        </Button>
      </div>
    </div>
  );
}
